import { Box, Switch } from '@material-ui/core'
import React, { useState } from 'react'
import CustomLabel from '../CustomLabel'

export default function Notifications() {
  const [state, setstate] = useState(true)
  const [state1, setstate1] = useState(true)
  const [state2, setstate2] = useState(false)

  const field = [
    {
      label: 'Push Notifications Alert',
      check: <Switch checked={state} onChange={(e) => setstate(e.target.checked)} />,
    },
    { label: 'Email Notifications', check: <Switch checked={state1} onChange={(e) => setstate1(e.target.checked)} /> },
    { label: 'Sms Alert', check: <Switch checked={state2} onChange={(e) => setstate2(e.target.checked)} /> },
  ]
  return (
    <div>
      {field.map((item, index) => (
        <Box display="flex" justifyContent="space-between">
          <CustomLabel label={item.label} />
          {item.check}
        </Box>
      ))}
    </div>
  )
}
